import Config from "../config.json";
import { io } from 'socket.io-client';

const url = Config.WebApps.Model.Websocket.Protocol + "://" +
    Config.WebApps.Model.Websocket.Host + ":" +
    Config.WebApps.Model.Websocket.Port;

// eslint-disable-next-line no-undef
export const socket = io(url, {
    autoConnect: false,
    secure: true,
    transports: ["websocket"]
});

